import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useMutation, useQuery } from "react-query";
//prime React
import { Steps } from "primereact/steps";
import { Button } from "primereact/button";
import Logo from "./EnterpriseSettings/EnterpriseDetails/Logo";
//components
import Input from "../../components/input/Input";
import Select from "../../components/input/Select";
import Toggle from "../../components/button/Toggle";
import NumberInput from "../../components/input/NumberInput";
import OwnersSelect from "../../components/owners/OwnersSelect";
//services
import { getIndex } from "../../services/GlobalRoles/getIndex";
import { getOwner } from "../../services/GlobalRoles/getOwner";
import { postEnterprise } from "../../services/SalesManagement/postEnterprise";
//utils
import { queryClient } from "../../utils/queryClient";
import { useAppContext } from "../../context/AppContext";

export default function NewEnterprise({ setShowModal }) {
  const { permissions } = useAppContext();
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [selectIndexData, setSelectIndexData] = useState([]);

  const defaultValues = {
    title: "",
    enable_report_dimob: false,
    enable_management: false,
    late_fee: 2.0,
    late_interest: 1,
    show_app: false,
    show_files_app: false
  };

  const form = useForm({ defaultValues });
  const errors = form.formState.errors;

  const steps = [
    {
      label: "Empreendimento",
    },
    {
      label: "Taxas / Juros",
    },
  ];

  const { data: index, isLoading: loadingIndex } = useQuery({
    queryKey: ["index"],
    queryFn: () => getIndex(),
    enabled: !!permissions?.includes("149"),
  });

  const nextStep = () => {
    setActiveIndex(activeIndex + 1);
  };

  useEffect(() => {
    if (index) {
      setSelectIndexData(
        index.map((dado) => ({
          value: dado.id,
          label: dado.name,
        }))
      );
    }
  }, [index]);

  const { mutateAsync: postEnterpriseFn } = useMutation({
    mutationFn: postEnterprise,
    onSuccess(res, variables) {
      queryClient.setQueryData(["enterprise"], (data) => {
        return [
          ...data,
          {
            ...variables,
            id: res.data.id,
            files: [{ path: variables.file }],
            lands_stauts_count: [],
          },
        ];
      });
    },
    onError(error) {
      console.log(error);
    },
  });

  const onSubmit = async (data) => {
    setLoading(true);
    const owners = data.ownerFields;
    delete data.ownerFields;
    const { ...rest } = data;

    if (Object.values(data).some((value) => value === undefined)) {
      toast.error("Informe todas as informações para criar o empreendimento");
      setLoading(false);
      return;
    }

    const sendData = {
      ...rest,
      file: file,
      owners: owners
    };

    try {
      await postEnterpriseFn(sendData);
      setLoading(false);
      setShowModal(false);
      toast.success("Empreendimento cadastrado com sucesso!");
      form.reset();
      return;
    } catch (error) {
      setLoading(false);
      toast.error("Informe todas as informações para criar o empreendimento");
      return;
    }
  };

  const getFormErrorMessage = (name) => {
    return errors[name] ? (
      <small className="p-error">{errors[name].message}</small>
    ) : (
      <small className="p-error">&nbsp;</small>
    );
  };

  return (
    <>
      <Steps model={steps} activeIndex={activeIndex} />
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <div className="row">
          <div className="row d-flex mt-3">
            <div>
              {activeIndex === 0 && (
                <>
                  <div className="row col-md-12">
                    <Logo onFileChange={(e) => setFile(e)} />
                  </div>
                  <div className="row pt-4">
                    <div className="col-md-12 mt-2">
                      <OwnersSelect formEdit={form} />
                    </div>
                    <div className="col-md-6 mt-2">
                      <Input
                        name="title"
                        control={form.control}
                        label="Empreendimento *"
                        errors={errors}
                      />
                    </div>
                    <div className="col-md-6 mt-2">
                      <NumberInput
                        name="matricula"
                        required={true}
                        label="Nº Matricula Empreendimento *"
                        control={form.control}
                        errors={errors}
                        rules="Campo obrigatório."
                      />
                    </div>
                  </div>
                </>
              )}
              {activeIndex === 1 && (
                <div className="row">
                  <div className="col-md-4 mt-3">
                    <NumberInput
                      suffix="%"
                      label="Multa Atraso"
                      placeholder="0%"
                      max={100}
                      minFractionDigits={2}
                      name="late_fee"
                      control={form.control}
                      getFormErrorMessage={getFormErrorMessage}
                    />
                  </div>
                  <div className="col-md-4 mt-3">
                    <NumberInput
                      suffix="%"
                      placeholder="0%"
                      max={100}
                      label="Juros Atraso (ao mês)"
                      minFractionDigits={2}
                      name="late_interest"
                      control={form.control}
                      getFormErrorMessage={getFormErrorMessage}
                    />
                  </div>
                  <div className="col-md-4 mt-3">
                    <Select
                      name="index_id"
                      label="Índice Reajuste"
                      errors={errors}
                      isRequired={true}
                      control={form.control}
                      options={selectIndexData}
                      disabled={loadingIndex ? true : false}
                    />
                  </div>
                  {permissions?.includes("195") && (
                    <div className="col-md-6 mt-2">
                      <div className="mt-3">
                        <Toggle
                          name="show_app"
                          onLabel="Exibir no app"
                          offLabel="Exibir no app"
                          tooltip="Clique para exibir o empreendimento no app"
                          tooltipOptions={{ position: "top" }}
                          control={form.control}
                          getFormErrorMessage={getFormErrorMessage}
                        />
                      </div>
                    </div>
                  )}
                  {permissions?.includes("195") && (
                    <div className="col-md-6 mt-2">
                      <div className="mt-3">
                        <Toggle
                          name="show_files_app"
                          onLabel="Exibir documentos no app"
                          offLabel="Exibir documentos no app"
                          control={form.control}
                          getFormErrorMessage={getFormErrorMessage}
                        />
                      </div>
                    </div>
                  )}

                  {/* <div className="col-md-3 mt-2">
                    <div className="mt-3">
                      <Toggle
                        name="enable_management"
                        tooltip="Clique para habilitar a opção de relatório"
                        onLabel="Gestão"
                        tooltipOptions={{ position: "top" }}
                        offLabel="Gestão"
                        control={form.control}
                        getFormErrorMessage={getFormErrorMessage}
                      />
                    </div>
                  </div> */}
                </div>
              )}
            </div>
          </div>
        </div>

        <hr className="my-4" />
        <div className="col-md-12 text-end">
          {activeIndex === 0 && (
            <Button
              rounded
              label="Próximo"
              iconPos="right"
              className="p-inputtext-sm m-auto"
              icon="fa-solid fa-circle-chevron-right"
              onClick={nextStep}
            />
          )}
          {activeIndex === 1 && (
            <div className="col-md-12 justify-content-between d-flex">
              <div>
                <Button
                  rounded
                  label="Anterior"
                  className="p-inputtext-sm m-auto"
                  icon="fa-solid fa-circle-chevron-left"
                  onClick={() => setActiveIndex(activeIndex - 1)}
                />
              </div>
              <div>
                <Button
                  rounded
                  type="submit"
                  iconPos="right"
                  label="Finalizar"
                  loading={loading}
                  className="p-inputtext-sm m-auto"
                  icon="fa-solid fa-circle-chevron-right"
                />
              </div>
            </div>
          )}
        </div>
      </form>
    </>
  );
}
